module.exports = __webpack_public_path__ + "static/logo-black-bdb9025c70c5ecf60c28fd1f52de2e9d.svg";